import { useEffect, useState } from "react";
import { Col, Divider, Flex, Row, Typography, Tooltip, Skeleton } from "antd";
import useFetch from "../../../hooks/useFetch";
import { DATA_REFRESH_RATE } from "../../../configs/configs";

const { Title, Text } = Typography;

export default function PowerEnergyTab({ themeToken, deviceData, deviceID }) {
  const [fetchWrapper] = useFetch();

  const [firstLoad, setFirstLoad] = useState(true);
  const [data, setData] = useState([]);

  /* API to get device energy usage */
  function getPowerAndEnergy() {
    fetchWrapper({
      endpoint_url: "device_monitoring/getPowerAndEnergy",
      body: {
        device_id: deviceID,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setData(fetch_output.power_and_energy_data);
        }
        setFirstLoad(false);
      },
    });
  }

  useEffect(() => {
    if (deviceID) {
      getPowerAndEnergy();
    }

    // refresh data every configurable second
    const timer = setInterval(() => {
      getPowerAndEnergy();
    }, DATA_REFRESH_RATE * 1000);

    return () => {
      clearInterval(timer);
    };
  }, [deviceData]);

  return (
    <>
      {firstLoad ? (
        <Skeleton active />
      ) : (
        <div
          style={{
            maxHeight: "calc(70vh - 62px)",
            paddingTop: 12,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {data.map((row, rowIndex) => (
            <>
              <Row gutter={[48, 24]} key={rowIndex}>
                {row.map((item, colIndex) => (
                  <Col
                    key={colIndex}
                    xs={24}
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                    xxl={6}
                  >
                    <Flex vertical className="pr-5">
                      <Title level={5} style={{ marginTop: 0 }}>
                        {item.title}
                      </Title>
                      {item.values.map((value, valueIndex) => (
                        <Flex
                          justify="space-between"
                          align="center"
                          key={valueIndex}
                        >
                          <Text>{value.label}</Text>
                          <Tooltip
                            title={
                              value.value === "- "
                                ? "There is an issue with data quality. The value is last updated at " +
                                  value.valueDateTime
                                : value.valueDateTime !== "N/A"
                                ? "Last update: " + value.valueDateTime
                                : ""
                            }
                          >
                            <Text>{value.value}</Text>
                          </Tooltip>
                        </Flex>
                      ))}
                    </Flex>
                  </Col>
                ))}
              </Row>
              {rowIndex < data.length - 1 && <Divider />}
            </>
          ))}
        </div>
      )}
    </>
  );
}
